"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function SDK(baseUrl, fetch, cacheInterface) {
  function _fetchJson(url) {
    var $args = arguments;
    return new Promise(function ($return, $error) {
      var options, res, _res, data, text;
      options = $args.length > 1 && $args[1] !== undefined ? $args[1] : {};
      if (options && options.body) {
        options.headers = _objectSpread(_objectSpread({}, options.headers || {}), {}, _defineProperty({}, 'content-type', 'application/json'));
      }
      // some of the sdks are used in the browswer where the native fetch is used.
      if (typeof window === 'undefined') {
        options.responseType = 'json';
        return Promise.resolve(fetch("".concat(baseUrl).concat(url), options)).then(function ($await_5) {
          try {
            res = $await_5;
            return $return(res.body);
          } catch ($boundEx) {
            return $error($boundEx);
          }
        }, $error);
      } else {
        return Promise.resolve(fetch("".concat(baseUrl).concat(url), options)).then(function ($await_6) {
          try {
            _res = $await_6;
            if (_res.ok) {
              return Promise.resolve(_res.json()).then($return, $error);
            } else {
              if (_res.headers.get('Content-Type').indexOf('application/json') !== -1) {
                return Promise.resolve(_res.json()).then(function ($await_8) {
                  try {
                    data = $await_8;
                    return $error(_objectSpread({
                      status: _res.status
                    }, data));
                  } catch ($boundEx) {
                    return $error($boundEx);
                  }
                }, $error);
              }
              return Promise.resolve(_res.text()).then(function ($await_9) {
                try {
                  text = $await_9;
                  return $error(text);
                } catch ($boundEx) {
                  return $error($boundEx);
                }
              }, $error);
            }
            return $If_1.call(this);
          } catch ($boundEx) {
            return $error($boundEx);
          }
        }.bind(this), $error);
      }
      function $If_1() {
        return $return();
      }
      return $If_1.call(this);
    });
  }
  return {
    searchRecognitions: function searchRecognitions(filters) {
      return new Promise(function ($return, $error) {
        return Promise.resolve(_fetchJson('/recognitions/search', {
          method: 'POST',
          body: JSON.stringify(filters)
        })).then($return, $error);
      });
    },
    createRecognition: function createRecognition(body) {
      return new Promise(function ($return, $error) {
        return Promise.resolve(_fetchJson('/recognitions', {
          method: 'POST',
          body: JSON.stringify(body)
        })).then($return, $error);
      });
    },
    updateRecognition: function updateRecognition(recognitionId, body) {
      return new Promise(function ($return, $error) {
        return Promise.resolve(_fetchJson("/recognitions/".concat(recognitionId), {
          method: 'PUT',
          body: JSON.stringify(body)
        })).then($return, $error);
      });
    },
    deleteRecognition: function deleteRecognition(recognitionId) {
      return new Promise(function ($return, $error) {
        return Promise.resolve(_fetchJson("/recognitions/".concat(recognitionId), {
          method: 'DELETE'
        })).then($return, $error);
      });
    },
    reinstateRecognition: function reinstateRecognition(recognitionId) {
      return new Promise(function ($return, $error) {
        return Promise.resolve(_fetchJson("/recognitions/".concat(recognitionId, "/reinstate"), {
          method: 'PUT'
        })).then($return, $error);
      });
    },
    searchActivityConfig: function searchActivityConfig(filters) {
      return new Promise(function ($return, $error) {
        return Promise.resolve(_fetchJson('/activity-config/search', {
          method: 'POST',
          body: JSON.stringify(filters)
        })).then($return, $error);
      });
    },
    createActivityConfig: function createActivityConfig(body) {
      return new Promise(function ($return, $error) {
        return Promise.resolve(_fetchJson('/activity-config', {
          method: 'POST',
          body: JSON.stringify(body)
        })).then($return, $error);
      });
    },
    getActivityConfigById: function getActivityConfigById(id) {
      return new Promise(function ($return, $error) {
        return Promise.resolve(_fetchJson("/activity-config/".concat(encodeURIComponent(id)))).then($return, $error);
      });
    },
    updateActivityConfigById: function updateActivityConfigById(id, body) {
      return new Promise(function ($return, $error) {
        return Promise.resolve(_fetchJson("/activity-config/".concat(encodeURIComponent(id)), {
          method: 'PUT',
          body: JSON.stringify(body)
        })).then($return, $error);
      });
    },
    deleteActivityConfigById: function deleteActivityConfigById(id) {
      return new Promise(function ($return, $error) {
        return Promise.resolve(_fetchJson("/activity-config/".concat(encodeURIComponent(id)), {
          method: 'DELETE'
        })).then($return, $error);
      });
    },
    searchRewardChoices: function searchRewardChoices() {
      var $args = arguments;
      return new Promise(function ($return, $error) {
        var filters;
        filters = $args.length > 0 && $args[0] !== undefined ? $args[0] : {};
        return Promise.resolve(_fetchJson('/reward-choices/search', {
          method: 'POST',
          body: JSON.stringify(filters)
        })).then($return, $error);
      });
    },
    searchProgramsAndRewardChoices: function searchProgramsAndRewardChoices() {
      var $args = arguments;
      return new Promise(function ($return, $error) {
        var filters;
        filters = $args.length > 0 && $args[0] !== undefined ? $args[0] : {};
        return Promise.resolve(_fetchJson('/programs/reward-choices/search', {
          method: 'POST',
          body: JSON.stringify(filters)
        })).then($return, $error);
      });
    },
    handleCelebrationIneligible: function handleCelebrationIneligible(body) {
      return new Promise(function ($return, $error) {
        return Promise.resolve(_fetchJson('/recipient', {
          method: 'DELETE',
          body: JSON.stringify(body)
        })).then($return, $error);
      });
    },
    handleCelebrationEligible: function handleCelebrationEligible(body) {
      return new Promise(function ($return, $error) {
        return Promise.resolve(_fetchJson('/recipient', {
          method: 'POST',
          body: JSON.stringify(body)
        })).then($return, $error);
      });
    },
    getMyPreferences: function getMyPreferences() {
      return new Promise(function ($return, $error) {
        return Promise.resolve(_fetchJson('/preferences', {
          method: 'GET'
        })).then($return, $error);
      });
    },
    saveMyPreferences: function saveMyPreferences(preferences) {
      return new Promise(function ($return, $error) {
        return Promise.resolve(_fetchJson('/preferences', {
          method: 'POST',
          body: JSON.stringify(preferences)
        })).then($return, $error);
      });
    },
    getUserPreferences: function getUserPreferences(rosterPersonId) {
      return new Promise(function ($return, $error) {
        return Promise.resolve(_fetchJson("/preferences/".concat(encodeURIComponent(rosterPersonId)), {
          method: 'GET'
        })).then($return, $error);
      });
    },
    genericRequest: function genericRequest(url, method, body) {
      return new Promise(function ($return, $error) {
        if (body) {
          return Promise.resolve(_fetchJson(url, {
            method: method,
            body: JSON.stringify(body)
          })).then($return, $error);
        }
        return Promise.resolve(_fetchJson(url, {
          method: method
        })).then($return, $error);
      });
    }
  };
}
var noCache = {
  get: function get() {
    return undefined;
  },
  set: function set(key, value, lifetimeMins) {
    return value;
  },
  remove: function remove(key) {
    return undefined;
  },
  clear: function clear() {
    return undefined;
  }
};
module.exports = function (url, customFetch) {
  var cacheInterface = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : noCache;
  if (typeof customFetch !== 'function') {
    throw new Error("".concat(_typeof(customFetch), " is not a function"));
  }
  return new SDK(url, customFetch, cacheInterface);
};
//# sourceMappingURL=index.js.map